import React from "react";
import classNames from "classnames";
import { useTranslation } from "hooks";
import { Dialog, Button, Typography } from "components";
import styles from "./AcceptDialog.module.css";

interface AcceptDialogProps {
  opened: boolean;
  setOpened: React.Dispatch<React.SetStateAction<boolean>>;
  accept: () => void;
}

const AcceptDialog: React.FC<AcceptDialogProps> = ({
  opened,
  setOpened,
  accept,
}) => {
  const { t } = useTranslation();
  const acceptHandler = (): void => {
    accept();
    setOpened(false);
  };

  return (
    <Dialog
      opened={opened}
      onClose={() => setOpened(false)}
      title={
        <Typography component="h2" variant="h4">
          {t("offline.acceptDialogTitle")}
        </Typography>
      }
      overlayClassName={classNames(styles.acceptModal, styles.overlay)}
      className={classNames(styles.acceptModal, styles.dialog)}
    >
      {t("offline.acceptDialogDescription")}
      <div className={styles.buttons}>
        <Button
          variant="secondary"
          size="small"
          onClick={() => setOpened(false)}
        >
          {t("offline.cancel")}
        </Button>
        <Button
          size="small"
          onClick={acceptHandler}
          className={styles.clearButton}
        >
          {t("offline.clear")}
        </Button>
      </div>
    </Dialog>
  );
};

export default AcceptDialog;
